@if(match?.matchStatus !== 'TBP') {
  <div class="swap" (click)="officialViewService.swapSides(match)">
    <ion-icon name="swap-horizontal"></ion-icon>
  </div>
}